import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';

( function( app ) {
  const COMPONENT = {
    init: function() {
      const scrollingTextCard = document.querySelectorAll( '.scrolling-text-card ' );
      const prefersReduced = window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;
      const scrollSpeed = prefersReduced ? 0 : 0.5;

      if ( scrollingTextCard ) {
        scrollingTextCard.forEach( ( component ) => {
          const topEl = component.querySelector( '.splide--scrolling-text-top' );
          if ( topEl ) {
            new Splide( topEl, {
              type: 'loop',
              arrows: false,
              pagination: false,
              drag: false,
              autoWidth: true,
              gap: '3rem',
              pauseOnHover: false,
              pauseOnFocus: false,
              // autoScroll: {speed: scrollSpeed},
            } ).mount( {AutoScroll} );
          }

          const bottomEl = component.querySelector( '.splide--scrolling-text-bottom' );
          if ( bottomEl ) {
            new Splide( bottomEl, {
              type: 'loop',
              arrows: false,
              pagination: false,
              drag: false,
              autoWidth: true,
              gap: '3rem',
              direction: 'rtl', // right-to-left
              pauseOnHover: false,
              pauseOnFocus: false,
              autoScroll: {speed: scrollSpeed},
            } ).mount( {AutoScroll} );
          }
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'scrolling-text-card', COMPONENT );
} )( app );
